export function WorldClassicIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="24" cy="24" r="16" />
      <path d="M14 18h20" />
      <path d="M14 30h20" />
      <path d="M18 10v28" />
      <path d="M30 10v28" />
      <circle cx="24" cy="24" r="4" fill="currentColor" opacity="0.2" />
      <circle cx="24" cy="24" r="4" />
    </svg>
  );
}
